import { SubmissionAttachment } from './submission-attachment';
import { Deserializable } from '../protocols/deserializable';

export class UpdateVariableBenefitConfigurationSubmissionData implements Deserializable {
  public effectiveDate!: string;
  public desiredFundingAmount!: number;
  public useEntireBalance!: boolean;
  public consentWaiverDateSigned!: string | null;
  public consentWaiverEffectiveDate!: string | null;
  public submissionConsentWaiver!: SubmissionAttachment | null;
  public memberConsentWaiver!: SubmissionAttachment | null;

  public onDeserialize(): void {
    if (!!this.submissionConsentWaiver) {
      this.submissionConsentWaiver = window?.injector?.Deserialize?.instanceOf(
        SubmissionAttachment,
        this.submissionConsentWaiver
      );
    }

    if (!!this.memberConsentWaiver) {
      this.memberConsentWaiver = window?.injector?.Deserialize?.instanceOf(
        SubmissionAttachment,
        this.memberConsentWaiver
      );
    }
  }
}
